import { lazy } from 'react';
import { importWithRetry } from './appVersion';

export const lazyWithRetry = ((importer) => lazy(() => importWithRetry(importer))) as typeof lazy;
